export interface DownloadFile {
  url: string
  name?: string
  task_name?: string
}

export interface DownloadProgress {
  type: 'PROGRESS' | 'SUCCESS' | 'ERROR' | 'WARNING'
  message: string
  progress?: number
  zipBlob?: Blob
  zipName?: string
}

export class ZipDownloader {
  private worker: Worker | null = null
  private onProgress?: (progress: DownloadProgress) => void
  private onComplete?: (blob: Blob, fileName: string) => void
  private onError?: (error: string) => void

  constructor() {
    this.initWorker()
  }

  private initWorker() {
    try {
      this.worker = new Worker('/zipDownloadWorker.js')

      this.worker.onmessage = e => {
        const { type, message, progress, zipBlob, zipName } = e.data

        switch (type) {
          case 'PROGRESS':
            this.onProgress?.({ type, message, progress })
            break
          case 'WARNING':
            this.onProgress?.({ type, message })
            break
          case 'SUCCESS':
            this.onProgress?.({ type, message, progress })
            if (zipBlob && zipName) {
              this.onComplete?.(zipBlob, zipName)
            }
            break
          case 'ERROR':
            this.onError?.(message)
            break
        }
      }

      this.worker.onerror = error => {
        console.error('Worker error:', error)
        this.onError?.('Worker 执行出错')
      }
    } catch (error) {
      console.error('Worker 初始化失败:', error)
      throw new Error('浏览器不支持 Web Worker 或初始化失败')
    }
  }

  public downloadAndZip(
    files: DownloadFile[],
    zipName: string = 'PPT2SEEWO_files.zip',
    callbacks: {
      onProgress?: (progress: DownloadProgress) => void
      onComplete?: (blob: Blob, fileName: string) => void
      onError?: (error: string) => void
    } = {},
  ) {
    if (!this.worker) {
      callbacks.onError?.('Worker 未初始化')
      return
    }

    if (!files || files.length === 0) {
      callbacks.onError?.('没有可下载的文件')
      return
    }

    this.onProgress = callbacks.onProgress
    this.onComplete = callbacks.onComplete
    this.onError = callbacks.onError

    this.worker.postMessage({
      type: 'DOWNLOAD_AND_ZIP',
      data: {
        files: files.filter(file => file.url), // 过滤掉没有url的文件
        zipName,
      },
    })
  }

  public destroy() {
    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }
  }
}

// 用于下载blob文件的工具函数
export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
